export default __webpack_public_path__ + "static/media/8.0e9bec56.jpeg";